import { RouteObject } from "react-router-dom";
import pathRoutes from "../../../routes/pathRoutes";
import Authenticated from "../../../utils/Authenticated";
import TransitDosesListLayout from "../layouts/layout";
import TransitDoseList from "../transitDose";
import EditTransit from "../edittransit";
import LayoutEditTransitDoses from "../layouts/layoutEdit";
import { PrivateRoutes } from "@app/utils/PrivateRoutes";
import { RolesTypes } from "@app/pages/users/utils/helpers";

const routesTransit: RouteObject = {
  path: pathRoutes.ADMIN_TRANSIT,
  element: (
    <Authenticated>
      <TransitDosesListLayout />
    </Authenticated>
  ),
  children: [
    {
      path: "",
      index: true,
      element: (
        <Authenticated>
          <TransitDoseList />
        </Authenticated>
      ),
    },
    {
      path: "nuevo",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <LayoutEditTransitDoses />
        </PrivateRoutes>
      ),
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditTransit />
            </Authenticated>
          ),
        },
      ],
    },
    {
      path: "editar/:idTransitDoses",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <LayoutEditTransitDoses />
        </PrivateRoutes>
      ),
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditTransit />
            </Authenticated>
          ),
        },
      ],
    },
  ],
};

export default routesTransit;
